const en = {
  title: 'Tickets',
  description: "What the app's tickets page shows. Its header image is on the Info & Layout tab.",
  descriptionLabel: 'Description',
  descriptionHelp: 'HTML formatting supported, e.g. <b>bold</b>, <i>italic</i>.',
  link: 'Ticket link',
  linkHelp: "The page the app's buy ticket buttons open.",
};

const fr: typeof en = {
  title: 'Billetterie',
  description: "Ce qu'affiche la page billetterie de l'app. Son image d'en-tête se trouve dans l'onglet Infos & mise en page.",
  descriptionLabel: 'Description',
  descriptionHelp: 'Mise en forme HTML acceptée, par ex. <b>gras</b>, <i>italique</i>.',
  link: 'Lien de la billetterie',
  linkHelp: "La page qu'ouvrent les boutons d'achat de billets de l'app.",
};

const messages = { en, fr };
export default messages;
